import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CopyToClipboardDirective } from '@shared/ui';
import { ButtonSpinComponent } from '@spaq/shared/components/button-spin/button-spin.component';
import { ContentLoaderComponent, ContentLoaderModule } from '@spaq/shared/components/content-loader';
import { LayoutSubNavComponent } from '@spaq/shared/components/layout/layout-sub-nav';
import { MessageStateComponent } from '@spaq/shared/components/message-state.component';
import { SpinnerStateComponent } from '@spaq/shared/components/spinner-state/spinner-state.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ButtonComponent } from '@spaq/shared/components/button';
import { ErrorComponent } from '@spaq/shared/components/error';
import { FormComponent } from '@spaq/shared/components/form';
import { LinkChoiceComponent } from '@spaq/shared/components/link-choice';
import { NoResultComponent } from '@spaq/shared/components/no-result';
import { SubmitCaptchaComponent } from '@spaq/shared/components/submit-captcha';
import { SubmitComponent } from '@spaq/shared/components/submit';
import { SuccessComponent } from '@spaq/shared/components/success';
import { WarningComponent } from '@spaq/shared/components/warning';
import { MarkdownComponent } from '@spaq/shared/components/markdown/markdown.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { NgxMdModule } from 'ngx-md';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';

@NgModule({
	declarations: [
		FormComponent,
		SubmitComponent,
		ButtonComponent,
		SubmitCaptchaComponent,
		ErrorComponent,
		LinkChoiceComponent,
		SuccessComponent,
		WarningComponent,
		NoResultComponent,
		MessageStateComponent,
		SpinnerStateComponent,
		FormComponent,
		ButtonSpinComponent,
		FormComponent,
		LayoutSubNavComponent,
		MarkdownComponent
	],
	exports: [
		FormComponent,
		SubmitComponent,
		ButtonComponent,
		SubmitCaptchaComponent,
		ErrorComponent,
		LinkChoiceComponent,
		SuccessComponent,
		WarningComponent,
		NoResultComponent,
		MessageStateComponent,
		SpinnerStateComponent,
		FormComponent,
		ButtonSpinComponent,
		FormComponent,
		LayoutSubNavComponent,
		MarkdownComponent,
		ContentLoaderComponent,
		CopyToClipboardDirective
	],
	imports: [
		CopyToClipboardDirective,
		IndicatorsModule,
		NotificationModule,
		TranslateModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		ButtonsModule,
		ContentLoaderModule,
		NgxMdModule
	],
	providers: []
})
export class SharedComponentsModule {}
